<template>
  <iframe
    src="https://superset.gie-us.es/superset/dashboard/p/nLBpMqLKpZA/"
    class="superset-iframe"
    frameborder="0"
    allowfullscreen
  ></iframe>
</template>

<script>
export default {
  name: 'SupersetEmbed'
}
</script>

<style scoped>
.superset-iframe {
  width: 100%;
  height: calc(100vh - 57px); /* Ajusta restando la altura del navbar */
  border: none;
}
</style>